import { ReactComponent as DuplicateIcon } from "assets/images/iconsV2/copy.svg";
import { FormattedMessage } from "react-intl";
import testIds from "constants/testIds";
import PropTypes from "prop-types";
import ActionButton from "../../common/TopNavV2/TopNavActions/ShipperProviderActions/ActionButton";

interface IDuplicateMenuItemProps {
  openDuplicateDialog: () => void;
}

function DuplicateMenuItem({ openDuplicateDialog }: IDuplicateMenuItemProps) {
  return (
    <ActionButton
      onClick={() => {
        openDuplicateDialog();
      }}
      icon={<DuplicateIcon width={16} height={16} />}
      title={<FormattedMessage id="general.duplicate" defaultMessage="Duplicate" />}
      testId={testIds.SHIPMENT_DASHBOARD_DUPLICATE_BUTTON}
    />
  );
}

DuplicateMenuItem.propTypes = {
  openDuplicateDialog: PropTypes.func.isRequired,
};

export default DuplicateMenuItem;
